import {
  DigitalAudienceCustomBuilderFilters,
  DigitalAudienceCustomBuilderFiltersResponse,
  DigitalAudienceCustomBuilderSelectedFilters,
} from '../../types/digital-audience/DigitalAudienceCustomBuilder';
import {
  DigitalAudienceCustomBuilderActions,
  DigitalAudienceAudienceBuilderActionsType,
} from './DigitalAudienceAudienceBuilderActions';

export type DigitalAudienceCustomBuilderState = {
  filtersResponse: DigitalAudienceCustomBuilderFiltersResponse;
  filters: DigitalAudienceCustomBuilderFilters;
  selectedFilters: DigitalAudienceCustomBuilderSelectedFilters;
  isLoading: boolean;
  signal: boolean;
};

export type DigitalAudienceAudienceBuilderMainState = {
  isBlockedModalOpened: boolean;
};

export type DigitalAudienceAudienceBuilderState = {
  main: DigitalAudienceAudienceBuilderMainState;
  customBuilder: DigitalAudienceCustomBuilderState;
}

const initialSelectedFiltersState = () => ({
  bps: { min: 50, max: 100 },
  customerTypes: [],
  isCurrentVehicleOptionsActive: false,
  currentVehicle: {
    dealTypes: [],
    leaseMileageStatuses: [],
    makes: [],
    models: [],
    mileage: { min: 0, max: 100000 },
    vehicleTypes: [],
    years: [],
    remainingPayments: { min: 0, max: 72 },
    warrantyExpired: [],
  },
  isReplacementVehicleOptionsActive: false,
  replacementVehicle: {
    dealTypes: [],
    makes: [],
    models: [],
    vehicleTypes: [],
    years: [],
  },
  signal: false,
});

const initialDigitalAudienceAudienceBuilderState = (): DigitalAudienceAudienceBuilderState => ({
  main: {
    isBlockedModalOpened: false
  },
  customBuilder: {
    filtersResponse: {
      bps: { min: 0, max: 0 },
      customerTypes: [],
      currentVehicle: {
        dealTypes: [],
        leaseMileageStatuses: [],
        makesWithModels: [],
        mileage: { min: 0, max: 0 },
        vehicleTypes: [],
        years: [],
        remainingPayments: { min: 0, max: 0 },
        warrantyExpired: [],
      },
      replacementVehicle: {
        dealTypes: [],
        makesWithModels: [],
        vehicleTypes: [],
        years: [],
      },
    },
    filters: {
      bps: { min: 0, max: 0 },
      customerTypes: [],
      currentVehicle: {
        dealTypes: [],
        leaseMileageStatuses: [],
        makes: [],
        models: [],
        mileage: { min: 0, max: 0 },
        vehicleTypes: [],
        years: [],
        remainingPayments: { min: 0, max: 0 },
        warrantyExpired: [],
      },
      replacementVehicle: {
        dealTypes: [],
        makes: [],
        models: [],
        vehicleTypes: [],
        years: [],
      },
    },
    selectedFilters: initialSelectedFiltersState(),
    isLoading: false,
    signal: false
  }
});

export const digitalAudienceAudienceBuilderReducer = (
  state: DigitalAudienceAudienceBuilderState = initialDigitalAudienceAudienceBuilderState(),
  action: DigitalAudienceCustomBuilderActions,
): DigitalAudienceAudienceBuilderState => {
  switch (action.type) {
    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS_RESPONSE: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          filtersResponse: action.payload.filtersResponse,
        }        
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_FILTERS: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          filters: action.payload.filters,
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          selectedFilters: action.payload.filters,
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_LOADING: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          isLoading: action.payload,
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.RESET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SELECTED_FILTERS: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          selectedFilters: initialSelectedFiltersState(),
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_CURRENT_VEHICLE_OPTIONS_ACTIVE: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          selectedFilters: {
            ...state.customBuilder.selectedFilters,
            isCurrentVehicleOptionsActive: action.payload,
          },
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_IS_REPLACEMENT_VEHICLE_OPTIONS_ACTIVE: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          selectedFilters: {
            ...state.customBuilder.selectedFilters,
            isReplacementVehicleOptionsActive: action.payload,
          },
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_CUSTOM_BUILDER_SIGNAL: {
      return {
        ...state,
        customBuilder: {
          ...state.customBuilder,
          signal: action.payload,
        }
      };
    }

    case DigitalAudienceAudienceBuilderActionsType.SET_DIGITAL_AUDIENCE_AUDIENCE_BUILDER_BLOCKED_MODAL: {
      return {
        ...state,
        main: {
          isBlockedModalOpened: action.payload
        }
      };
    }

    default:
      return state;
  }
};
